import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect callbacks when the app loads
// This is essential for loginRedirect to work properly
msalInstance
  .initialize()
  .then(() => {
    return msalInstance.handleRedirectPromise();
  })
  .then((response) => {
    if (response) {
      console.log("Redirect login successful:", response.account?.username);
    }
  })
  .catch((error) => {
    console.error("Error initializing MSAL or handling redirect:", error);
  });
